import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { create } from 'mobx-persist';
import { RouterStore, syncHistoryWithStore } from 'mobx-react-router';
import { ApolloProvider } from 'react-apollo';
import { useStrict } from 'mobx';
import { Provider } from 'mobx-react';
import { IntlProvider } from 'react-intl';
import { ThemeProvider } from 'styled-components';
import createBrowserHistory from 'history/createBrowserHistory';
import registerServiceWorker from './registerServiceWorker';
import FileUploadStore from './containers/analyse/store/FileUploadStore';
import UiState from './store/UiState';
import theme from './theme';

// eslint-disable-next-line import/extensions
import './theme/global-styles.js';

// import views
import App from './App';

// Import i18n messages
import { translationMessages } from './i18n';
import AuthStore from './containers/login/store/AuthStore';
import { initialiseAPI } from './services/api';
import { appSyncClient } from './services/aws/app-sync';

const browserHistory = createBrowserHistory();

useStrict(false);

// setup all stores
const uiState = new UiState();
const routing = new RouterStore();
const authStore = new AuthStore(uiState);
const fileUploadStore = new FileUploadStore(uiState);

const stores = {
  routing,
  fileUploadStore,
  uiState,
  authStore
};

const history = syncHistoryWithStore(browserHistory, routing);

const render = () => {
  ReactDOM.render(
    <ApolloProvider client={appSyncClient}>
      <Provider {...stores}>
        <IntlProvider locale="en" messages={translationMessages.en}>
          <ThemeProvider theme={theme}>
            <App history={history} />
          </ThemeProvider>
        </IntlProvider>
      </Provider>
    </ApolloProvider>,
    document.getElementById('root')
  );
};

/**
 * responsible for persistance of stores every store we want te keep alive between refreshes
 * we have to wait for the persiststore finish before we can render our views
 */
const persistStores = async () => {
  const hydrate = create();
  await hydrate('uiState', stores.uiState);
  await hydrate('authStore', stores.authStore);

  await initialiseAPI();

  authStore.setLoginState();

  render();
};

registerServiceWorker();
persistStores();



// WEBPACK FOOTER //
// ./src/index.js